(function () {
  'use strict';

  angular
      .module('eltazkaraApp')
      .config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('categories', {
      parent: 'app',
      url: '/categories',
      views: {
        'content@': {
            templateUrl: 'components/categories/categories.html',
          controller: 'CategoriesController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    }).state('category', {
      parent: 'app',
      url: '/category/:id',
      views: {
        'content@': {
            templateUrl: 'components/categories/category.html',
          controller: 'CategoryController',
          controllerAs: 'vm'
        }
      },
      resolve: {
        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
          $translatePartialLoader.addPart('global');
        }]
      }
    });
  }
})()
